import { render, staticRenderFns } from "./ProjectObservationsFormMissing.vue?vue&type=template&id=e1e31532&"
import script from "./ProjectObservationsFormMissing.vue?vue&type=script&lang=js&"
export * from "./ProjectObservationsFormMissing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports